import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/system'
import { Collapse, IconButton, Typography, useTheme } from '@mui/material'
import { ChevronRight } from '@mui/icons-material'
import { Caption, H5 } from '../../../../layouts/TextStyles'
import {
    VideoNotesAnalysisState,
} from '../../../../features/types'
import VideonotesCardSection from './VideonotesCardSection'
import Document from '../../../../assets/icons/Documents/Document.svg'
import CircleCheck from '../../../../assets/icons/CircleCheck.svg'
import dayjs from 'dayjs'
import { capitalize } from '../../../../utils/functions'

interface Props {
    videonotes: VideoNotesAnalysisState
}

const TopicVideonotesCard: React.FC<Props> = ({ videonotes }) => {
    const theme = useTheme()
    const [expanded, setExpanded] = useState(false)
    const { formatMessage, locale } = useIntl()
    const textColor = videonotes?.point === null ? '#FFC107' : videonotes?.point > 0 ? '#4CAF50' : '#434343'
    const backgroundColor = videonotes?.point === null ? '#FBFFCF' : videonotes?.point > 0 ? '#D3FFC7' : '#F1F3F5'




    const styles = {
        wrapper: {
            border: `1px solid ${theme.palette.grey[100]}`,
            borderRadius: '8px',
            mb: 2,
        },
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: '8px',
            backgroundColor: backgroundColor,
            cursor: 'pointer',
            p: 1,
            pr: 2,
        },
        chevron: {
            transform: expanded ? 'rotate(90deg)' : 'rotate(0)',
            transition: '0.15s ease-in-out',
        },
        flexCenter: {
            display: 'flex',
            alignItems: 'center',
        },
        flexBetween: {
            display: 'flex',
            justifyContent: 'space-between',
            '@media (max-width: 768px)': {
                flexDirection: 'column',
                gap: 2,
                alignItems: 'flex-start',
            },
        },
        topicProgress: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            marginLeft: 1,
        },
        info: {
            gap: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '@media (max-width: 768px)': {
                gap: 6,
            },
        },
        textOverflow: {
            color: '#434343',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    }




    return (
        <Box sx={styles.wrapper}>
            <Box
                sx={styles.container}
                onClick={() => {
                    setExpanded(!expanded)
                }}
            >
                <Box sx={{ ...styles.flexCenter, width: '95%' }}>
                    <IconButton>
                        <ChevronRight sx={styles.chevron} />
                    </IconButton>
                    <Box sx={styles.topicProgress}>
                        <Box sx={styles.flexBetween}>
                            <Box>
                                <Typography sx={styles.textOverflow} variant="body1" fontWeight={600}>{videonotes?.[`topic${capitalize(locale)}`]}</Typography>
                                <Typography sx={styles.textOverflow} variant="body1">{videonotes?.videoLessonTitle}</Typography>
                            </Box>
                            <Box sx={styles.info}>
                                {videonotes?.point ?
                                    <>
                                        {videonotes?.checkedTime && <Typography variant="body2" sx={{ maxWidth: '150px' }}> {formatMessage({ id: 'checked_time' })}: {dayjs(videonotes?.checkedTime?.toString()).format('DD.MM.YYYY HH:mm')}</Typography>}
                                        <H5 color={textColor}>{videonotes?.point + ' ' + formatMessage({ id: 'points' })}</H5>
                                    </>
                                    :
                                    <H5 color={textColor}>{formatMessage({ id: 'sended' })}</H5>}
                            </Box>
                        </Box>
                    </Box>
                </Box>
                {videonotes?.point === null && <img src={Document} alt="Document" />}
                {videonotes?.point !== null && <img src={CircleCheck} alt="CircleCheck" />}
            </Box>

            <Collapse in={expanded}>
                <Box>
                    <VideonotesCardSection
                        videonotes={videonotes}
                    />
                </Box>
            </Collapse>
        </Box>
    )
}

export default TopicVideonotesCard
